import * as React from 'react';
import { getIn, FieldProps } from 'formik';

import styles from '../fieldStyles.scss';

import Autocomplete from 'buyside/components/presentation/Autocomplete/autocomplete';
import SearchIcon from 'buyside/svgs/search.svg';

interface fieldContainerProps {
  style?: React.CSSProperties;
}

export interface Suggestion {
  id: string;
  label?: string;
  value: string;
}

interface OptionalProps {
  label: string;
  locked: boolean;
  fieldContainerProps: fieldContainerProps;
  placeholder: string;
  icon: boolean;
  analyticsTag: string;
}

export interface AutocompleteProps<S = {}> extends FieldProps, OptionalProps {
  suggestions: Array<Suggestion & S>;
  changeIntercept: (query: string) => void;
  selectIntercept: (value: string, selectObject: Suggestion & S) => void;
}

class AutocompleteField<S = {}> extends React.Component<AutocompleteProps<S>> {
  static defaultProps: OptionalProps;

  render(): React.ReactElement {
    const {
      field,
      form: { touched, errors, isSubmitting, setFieldTouched },
      label,
      locked = false,
      fieldContainerProps,
      placeholder,
      suggestions,
      icon = false,
      analyticsTag,
      ...autocompleteProps
    } = this.props;
    const isTouched = getIn(touched, field.name);
    const error = getIn(errors, field.name);
    const inputProps = {
      id: field.name,
      className: `form-control ${styles.input}`,
      disabled: isSubmitting,
      onBlur: (): void => setFieldTouched(field.name),
      placeholder
    };
    return (
      <div className={styles.fieldContainer} {...fieldContainerProps}>
        <label htmlFor={field.name} className={styles.fieldLabel}>
          {label}
        </label>
        {locked ? (
          <div className={styles.fieldLocked}>{field.value}</div>
        ) : (
          <div className={styles.inputFieldGroup}>
            <Autocomplete
              analyticsTag={analyticsTag}
              initialValue={field.value}
              inputProps={inputProps}
              suggestions={suggestions}
              {...autocompleteProps}
            />
            {icon && <SearchIcon className={styles.searchIcon} />}
          </div>
        )}
        {isTouched && error && <div className={styles.fieldError}>{error}</div>}
      </div>
    );
  }
}

export default AutocompleteField;
